import { render, staticRenderFns } from "./DigitekaLogin.vue?vue&type=template&id=5c544fa5"
import script from "./DigitekaLogin.vue?vue&type=script&lang=js"
export * from "./DigitekaLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports